'use strict';

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.constructor");

var cache;
/**
 * Convert HTML entities to HTML characters.
 *
 * @param  {String} `str` String with HTML entities to un-escape.
 * @return {String}
 */

var unescape = module.exports = function (str) {
  if (str == null) return '';
  var re = cache || (cache = new RegExp('(' + Object.keys(chars).join('|') + ')', 'g'));
  return String(str).replace(re, function (match) {
    return chars[match];
  });
};

var chars = unescape.chars = {
  '&apos;': '\'',
  '&#39;': '\'',
  '&amp;': '&',
  '&gt;': '>',
  '&lt;': '<',
  '&quot;': '"'
};